import React from 'react';
import Style from '../shared/Style.js';
import Util from './Util.js';
import { ValueText, SuffixText } from "./DetailText.js";
import AttributeDetailRenderer from "./AttributeDetailRenderer.js";
import Formatters from '../../attribute/formatter/Formatters.js';
import I18nResolvers from '../../attribute/i18nResolver/I18nResolvers.js';
import InlineEditor from "../../attribute/editor/InlineEditor.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const EMPTY = {};
export default class UnitAttributeDetailRenderer extends AttributeDetailRenderer {
  getValueComponent(value, valueStyle, obj, cxt, {
    valueVariant
  }) {
    const {
      editable
    } = cxt;
    let content;
    if (value && value.length === 1) {
      content = /*#__PURE__*/_jsx(ValueText, {
        style: valueStyle,
        children: value?.[0]
      });
    } else {
      const unitStyle = Util.getStyle(this.detail.unit || EMPTY);
      const alignItems = Style.toFlexAlign(this.detail?.unit?.align || 'baseline');
      if (valueVariant) {
        content = /*#__PURE__*/_jsx(ValueText, {
          variant: valueVariant,
          style: valueStyle,
          children: `${value?.[0]}${value[1] != null ? ` ${value[1]}` : ''}`
        });
      } else {
        content = /*#__PURE__*/_jsxs("div", {
          style: {
            display: 'flex',
            alignItems,
            flexWrap: 'nowrap'
          },
          children: [/*#__PURE__*/_jsx(ValueText, {
            style: valueStyle,
            children: value && value[0]
          }), /*#__PURE__*/_jsx(SuffixText, {
            style: unitStyle,
            children: value?.[1]
          })]
        });
      }
    }
    const context = this.getContext(obj, cxt);
    if (this.detail.formatter) {
      context.formatter = this.detail.formatter;
    }
    return /*#__PURE__*/_jsx(InlineEditor, {
      usage: "detail",
      variant: valueVariant,
      editable: editable,
      attrName: this.name,
      object: obj,
      style: valueStyle,
      context: context,
      children: content
    }, this.name);
  }
  formatAndI18nResolveValue = value => {
    const formattedValue = Formatters.format(value, this.detail.formatter);
    if (formattedValue == null || formattedValue.length === 0 || typeof formattedValue[0] !== 'string') {
      return null;
    }
    return formattedValue.map(value => I18nResolvers.resolve(value, this.detail)).flat();
  };
}